<template>
    <!-- <CSelect
        :value.sync="language"
        :options="languages"
        @change="$emit('update:value',parseInt($event.target.value))"

        :label="label"
        :placeholder="placeholder"
        :size="size"
        :disabled="disabled"
        class="select-global-languages"
    /> -->
    <multiselect
        v-model="language"
        :placeholder="placeholder"
        :label="label"
        track-by="name"
        :options="languages"
        :option-height="20"
        :show-labels="false"
        :disabled="disabled"
        class="select-global-languages"
    >
        <template slot="singleLabel" slot-scope="props">
            <div class="option-selected-wrapper">
                <img class="option__image" :src="props.option.image" />
                <span class="option__desc">
                    <span class="option__title">
                        {{ props.option.name }}
                    </span>
                </span>
            </div>
        </template>
        <template slot="option" slot-scope="props">
            <div class="option-wrapper">
                <img class="option__image" :src="props.option.image" />
                <div class="option__desc">
                    <span class="option__title">{{ props.option.name }}</span>
                </div>
            </div>
        </template>
    </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { mapGetters } from "vuex";
import SelectLanguage from "@/components/elements/SelectLanguage";
import axios from "axios";
import languages from "@/assets/languages.json";
export default {
    name: "SelectGlobalLanguage",
    components: {
        SelectLanguage,
        Multiselect,
    },
    data() {
        return {
            language: null,
            languages: [],
        };
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        size: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters({
            storeLangLocale: "lang/locale",
            storeGlobalLanguages: "global/languages",
            storeGlobalLocales: "lang/locales",
            storeAuthUser: "auth/user",
        }),
    },
    watch: {
        storeLangLocale(newValue) {
            this.language = this.languages.find((lang) => {
                return newValue == lang.code;
            });
        },
        language(newValue, oldValue) {
            this.$store.dispatch("lang/setLocale", {
                locale: newValue.code,
            });
        },

    },
    methods: {
        getLanguagesCodes: async function () {
            try {
                let data = languages;
                // Filter by locales availables
                let locales = this.storeGlobalLocales;
                for (let i = 0; i < locales.length; i++) {
                    const element = locales[i];
                    let language = data.find(
                        (lang) => lang.code == element
                    );
                    if (language) {
                        this.languages.push(language);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
    async mounted() {
        await this.getLanguagesCodes();

        this.language = this.languages.find((lang) => {
            return this.storeLangLocale == lang.code;
        });
    },
};
</script>
<style>
.option__image {
    width: auto;
    height: 2rem;
}
</style>